import { ICommonIconProps } from "../interface";

const NavigateIcon = ({ IconColor }: ICommonIconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.18538 16.0687L8.81519 1.93138M8.81519 1.93138L1.93164 9.18512M8.81519 1.93138L16.0689 8.81492"
        stroke={IconColor || "currentColor"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default NavigateIcon;
